var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarpoolHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29434",
    "data-name": "Group 29434",
    transform: "translate(-8 -582.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(8 582.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "svgexport-17_9_",
    "data-name": "svgexport-17 (9)",
    transform: "translate(25 589.649)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50450",
    "data-name": "Path 50450",
    d: "M64.082,154.963a.586.586,0,0,1-.489-.261l-2.5-3.788a.587.587,0,0,1,.977-.651l2.5,3.788a.587.587,0,0,1-.488.912Z",
    transform: "translate(-58.609 -144.132)",
    fill: "#4d354d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50451",
    "data-name": "Path 50451",
    d: "M357.7,154.963a.587.587,0,0,1-.488-.912l2.5-3.788a.587.587,0,0,1,.977.651l-2.5,3.788A.586.586,0,0,1,357.7,154.963Z",
    transform: "translate(-343.141 -144.132)",
    fill: "#331e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50452",
    "data-name": "Path 50452",
    d: "M241.587,150a.587.587,0,0,0-.587.587v3.56a.587.587,0,0,0,1.174,0v-3.56A.587.587,0,0,0,241.587,150Z",
    transform: "translate(-231.571 -144.131)",
    fill: "#4d354d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50453",
    "data-name": "Path 50453",
    d: "M256.587,154.147v-3.56A.587.587,0,0,0,256,150v4.734A.587.587,0,0,0,256.587,154.147Z",
    transform: "translate(-245.984 -144.131)",
    fill: "#331e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50454",
    "data-name": "Path 50454",
    d: "M89.308,242.2a1.758,1.758,0,0,0-1.67-1.2h-7.7a1.758,1.758,0,0,0-1.67,1.2l-1.493,4.519H90.8Z",
    transform: "translate(-73.772 -231.571)",
    fill: "#fb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50455",
    "data-name": "Path 50455",
    d: "M261.519,242.2a1.758,1.758,0,0,0-1.67-1.2H256v5.722h7.012Z",
    transform: "translate(-245.984 -231.571)",
    fill: "#f93"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50456",
    "data-name": "Path 50456",
    d: "M271,275.147h5.055l-1.235-3.746a.587.587,0,0,0-.557-.4H271Z",
    transform: "translate(-260.397 -260.397)",
    fill: "#f3e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50457",
    "data-name": "Path 50457",
    d: "M116.87,271h-3.262a.587.587,0,0,0-.557.4l-1.235,3.746h5.055Z",
    transform: "translate(-107.44 -260.397)",
    fill: "#fff2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50458",
    "data-name": "Path 50458",
    d: "M18.859,334.934l1.115-.587A2.978,2.978,0,0,0,17.059,332H2.974A2.968,2.968,0,0,0,0,334.934v2.348a.587.587,0,0,0,.587.587H19.446a.587.587,0,0,0,.587-.587v-1.761Z",
    transform: "translate(0 -319.01)",
    fill: "#fd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50459",
    "data-name": "Path 50459",
    d: "M266.016,337.282v-1.761l-1.174-.587,1.115-.587A2.978,2.978,0,0,0,263.043,332H256v5.869h9.429A.587.587,0,0,0,266.016,337.282Z",
    transform: "translate(-245.984 -319.01)",
    fill: "#fb3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_502",
    "data-name": "Ellipse 502",
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(8 0.351)",
    fill: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50460",
    "data-name": "Path 50460",
    d: "M183.934,90A2.938,2.938,0,0,0,181,92.934a.587.587,0,0,0,.587.587h4.7a.587.587,0,0,0,.587-.587A2.938,2.938,0,0,0,183.934,90Z",
    transform: "translate(-173.918 -86.479)",
    fill: "#fd3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50461",
    "data-name": "Path 50461",
    d: "M257.761,1.761A1.763,1.763,0,0,0,256,0V3.521A1.763,1.763,0,0,0,257.761,1.761Z",
    transform: "translate(-245.984)",
    fill: "#fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50462",
    "data-name": "Path 50462",
    d: "M258.934,92.934A2.938,2.938,0,0,0,256,90v3.521h2.348A.587.587,0,0,0,258.934,92.934Z",
    transform: "translate(-245.984 -86.479)",
    fill: "#fb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50463",
    "data-name": "Path 50463",
    d: "M392.761,3.521a1.761,1.761,0,1,1,1.761-1.761A1.763,1.763,0,0,1,392.761,3.521Z",
    transform: "translate(-375.702)",
    fill: "#fb9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50464",
    "data-name": "Path 50464",
    d: "M366.321,93.521h-4.734a.587.587,0,0,1-.587-.587A2.938,2.938,0,0,1,363.934,90a2.972,2.972,0,0,1,2.974,2.934A.587.587,0,0,1,366.321,93.521Z",
    transform: "translate(-346.875 -86.479)",
    fill: "#e64552"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50465",
    "data-name": "Path 50465",
    d: "M32.761,3.521a1.761,1.761,0,1,1,1.761-1.761A1.763,1.763,0,0,1,32.761,3.521Z",
    transform: "translate(-29.787)",
    fill: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50466",
    "data-name": "Path 50466",
    d: "M5.321,93.521H.587A.587.587,0,0,1,0,92.934,2.972,2.972,0,0,1,2.974,90a2.938,2.938,0,0,1,2.934,2.934A.587.587,0,0,1,5.321,93.521Z",
    transform: "translate(0 -86.479)",
    fill: "#9af"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50467",
    "data-name": "Path 50467",
    d: "M62.761,425.521a1.761,1.761,0,1,1,1.761-1.761A1.763,1.763,0,0,1,62.761,425.521Z",
    transform: "translate(-58.613 -405.489)",
    fill: "#4d354d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50468",
    "data-name": "Path 50468",
    d: "M362.761,425.521a1.761,1.761,0,1,1,1.761-1.761A1.763,1.763,0,0,1,362.761,425.521Z",
    transform: "translate(-346.875 -405.489)",
    fill: "#331e33"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_503",
    "data-name": "Ellipse 503",
    cx: 1,
    cy: 0.5,
    rx: 1,
    ry: 0.5,
    transform: "translate(3 17.351)",
    fill: "#fff2f2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_504",
    "data-name": "Ellipse 504",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(16 17.351)",
    fill: "#fff2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50469",
    "data-name": "Path 50469",
    d: "M453.328,392h-1.741a.587.587,0,1,0,0,1.174h1.8v-.587A2.942,2.942,0,0,0,453.328,392Z",
    transform: "translate(-433.354 -376.663)",
    fill: "#f93"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpoolHighlighted);
export default __webpack_public_path__ + "static/media/carpoolHighlighted.f24669c64360994157d8b3d0930b6787.svg";
export { ForwardRef as ReactComponent };